import React from "react";
import { Trans } from "react-i18next";

import { useGeolocationContext } from "../../../../../Geolocation/hooks/geolocationContext";

import Icon from "../../../../../../../Common/DesignSystem/Icons/Icon";
import { Tooltip, TooltipContent, TooltipTrigger } from "../../../../../../../Common/Tooltip";

import colours from '../../../../../../../Common/DesignSystem/Colours';
import { MarkerPopup } from "../../../../../Geolocation/GeolocationMap/MarkerPopup";

const IconTooltip = ({ children, icon, size, getColor }) => (
    <Tooltip>
        <TooltipTrigger>
            <div className="icon">
                <Icon name={icon} size={size} style={{ color: getColor() }} />
            </div>
        </TooltipTrigger>

        <TooltipContent className="vehicle-icon-tooltip">
            {children}
        </TooltipContent>
    </Tooltip>
)

export const FixedNameCell = ({ vehicle, children, orderNo }) => {
	const { vehicles: gpsDeviceVehicles } = useGeolocationContext();

    const vin = vehicle?.vin || vehicle?.VIN;
    const isLinked = vehicle.metadata?.createdBy === 'system';

    // TODO: Remove this workaround when we have the GPS device data in the vehicle list
    const gpsDeviceAttached = orderNo ? null : gpsDeviceVehicles.find(v => v.vin === vin);

    const getLinkIconColor = () => isLinked
        ? colours.accent.validate_green
        : colours.primary.grey04;

    const getGpsIconColor = () => {
        if (!gpsDeviceAttached?.gpsDevice) return colours.primary.grey04;

        return gpsDeviceAttached?.gpsDevice?.deviceStatus?.isDeviceCommunicating 
            ? colours.accent.validate_green
            : colours.accent.error_red;
    };

    return (
        <div className="vehicle-cell">
            {/* <div className="vehicle-status-icons">
                <div className="icon">
                    {Boolean(vehicle.isDamaged) && (
                        <Icon name="Damage" size={24} style={{ color: colours.accent.error_red }} />
                    )}
                </div>
            </div> */}

            {children}

            <div className="vehicle-data-icons">
                <IconTooltip icon="Link" size={18} getColor={getLinkIconColor}>
                    {isLinked ? (
                        <Trans>Data linked to DVAR database</Trans>
                    ) : (
                        <Trans>User created vehicle.<br />No data link</Trans>
                    )}
                </IconTooltip>

                {!orderNo && (
                    <IconTooltip icon="Pin" size={18} getColor={getGpsIconColor}>
                        {!gpsDeviceAttached?.gpsDevice ? (
                            <Trans>GPS device not installed</Trans>
                        ) : (
                            <div className="geolocation-data" >
                                <MarkerPopup vehicle={{ ...vehicle, gpsDevice: gpsDeviceAttached?.gpsDevice }} />
                            </div>
                        )}
                    </IconTooltip>
                )}
            </div>


            {orderNo && (
                <span className="vehicle-order-no">{orderNo}</span>
            )}
        </div>
    )
};
